module.exports = __webpack_public_path__ + "img/filter-grid.5d3426ef.svg";